import React from 'react';
import type { TaskListResponse } from '../../services/api/types.gen';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';

interface VisitTaskPickerProps {
  items: TaskListResponse[];
  valueId: string | null | undefined;
  onValueIdChange: (id: string | null) => void;
  placeholder: string;
  /** ClassName applied to the SelectTrigger for per-tab widths. */
  selectTriggerClassName?: string;
  /**
   * Render label text for a single option. Must be deterministic since
   * PatientDetail tests query for exact strings.
   */
  renderItemLabel: (task: TaskListResponse) => React.ReactNode;
  /** Rendered next to the Select when there is NO selected visit. */
  emptyHelper?: React.ReactNode;
  /** Rendered next to the Select when there IS a selected visit. */
  clearButtonClassName?: string;
  /** Clear button label (defaults to "Clear"). */
  clearLabel?: string;
}

export default function VisitTaskPicker({
  items,
  valueId,
  onValueIdChange,
  placeholder,
  selectTriggerClassName,
  renderItemLabel,
  emptyHelper,
  clearButtonClassName = 'text-xs text-muted-foreground underline hover:text-foreground',
  clearLabel = 'Clear',
}: VisitTaskPickerProps) {
  return (
    <>
      <Select
        value={valueId ?? ''}
        onValueChange={v => onValueIdChange(v || null)}
      >
        <SelectTrigger selectSize='sm' className={selectTriggerClassName}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {items.map(task => (
            <SelectItem key={task.id} value={task.id}>
              {renderItemLabel(task)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {valueId ? (
        <button
          type='button'
          onClick={() => onValueIdChange(null)}
          className={clearButtonClassName}
        >
          {clearLabel}
        </button>
      ) : (
        emptyHelper
      )}
    </>
  );
}
